<template>
  <div class="container">
    <main-title />
    <div class="card">
      <page-title back :text="pageTitle"></page-title>
      <div class="douyin-qr">
        <img src="@/assets/sqhsn-douyin.png" alt="抖音二维码" />
        <!-- <p>抖音扫码免费观看<br />快速提升作文技巧</p> -->
      </div>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" size="medium"
          label-position="left">

          <el-form-item :label="'学生姓名'" :prop="`authors[0].name`" :rules="{
            required: true,
            message: '请输入学生姓名',
            trigger: 'blur',
          }">
            <div class="inline">
              <el-input v-model="ruleForm.authors[0].name" placeholder="请输入学生姓名" class="authors">
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="所属地区" prop="region_id">
            <el-select v-model="ruleForm.city_id" filterable placeholder="市" @change="changeCity"
              style="width: 200px;margin-right: 20px;">
              <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="ruleForm.region_id" filterable placeholder="区/县" style="width: 200px;">
              <el-option v-for="item in countyList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校名称" prop="school_name">
            <el-input v-model="ruleForm.school_name" placeholder="请输入学校名称"></el-input>
          </el-form-item>
          <el-form-item label="选择组别" prop="group_name">
            <el-select v-model="ruleForm.group_name" filterable placeholder="选择组别">
              <el-option v-for="item in groupList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择年级" prop="grade">
            <el-select v-model="ruleForm.grade" filterable placeholder="选择年级">
              <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指导老师" prop="teacher">
            <el-input v-model="ruleForm.teacher" placeholder="请输入指导老师姓名"></el-input>
          </el-form-item>
          <el-form-item label="作品名称" prop="work_title">
            <el-input v-model="ruleForm.work_title" placeholder="请输入作品名称"></el-input>
          </el-form-item>
          <el-form-item label="上传作品" prop="attach_url">
            <uploader placeholder="仅限word文档" @on-success="attachSuccess" :before-upload="beforeUpload"
              :file-list="attachList"
              accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              type="input">
            </uploader>
          </el-form-item>
          <el-form-item>
            <el-button class="submit" type="danger" @click="toSave">提交</el-button>
          </el-form-item>
          <el-form-item>
            <div class="el-upload__tip">
              <i class="el-icon-warning-outline up_tip" style="transform:rotate(180deg);"></i>
              <div class="up_text">
                <p>1. 请确保您上传的作品内容已获得学生本人及其监护人同意。</p>
                <p>2. 请确保您已审核过上传内容，不得出现违法内容。</p>
                <br />
                <p>如有违反上述要求，组委会将取消相应作品参与资格。</p>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { saveMyWork, authFile, viewMyWork } from "@/api/work.js";
import { getCounty, getCity } from "@/api/school.js";
import uploader from "@/components/uploader";
export default {
  name: "myAddWork",
  data() {
    return {
      showContrl: true,
      attachList: [],
      pictureList: [],
      cityList: [],
      countyList: [],
      groupList: ['小学低年级组(1-3年级)', '小学高年级组(4-6年级)', '初中组', '高中组'],
      gradeList: [
        { id: 1, name: "一年级" },
        { id: 2, name: "二年级" },
        { id: 3, name: "三年级" },
        { id: 4, name: "四年级" },
        { id: 5, name: "五年级" },
        { id: 6, name: "六年级" },
        { id: 7, name: "七年级" },
        { id: 8, name: "八年级" },
        { id: 9, name: "九年级" },
        { id: 10, name: "高一" },
        { id: 11, name: "高二" },
        { id: 12, name: "高三" }
      ],
      ruleForm: {
        work_type: 3,
        work_title: "",
        group_name: "",
        authors: [
          {
            name: "",
          },
        ],
        grade: "",
        teacher: "",
        teacher_phone: "",
        school_name: "",
        province_id: 61,
        city_id: "",
        region_id: "",
        pic_url: "",
        attach_url: "",
        video_url: "",
      },
      rules: {
        work_title: [
          { required: true, message: "请输入作品名称", trigger: "blur" },
        ],
        group_name: [{ required: true, message: "选择组别", trigger: "change" }],
        grade: [{ required: true, message: "选择年级", trigger: "change" }],
        teacher: [
          { required: true, message: "请输入指导老师姓名", trigger: "blur" },
        ],
        school_name: [
          { required: true, message: "请输入学校名称", trigger: "blur" },
        ],
        region_id: [
          { required: true, message: "请选择所属区县", trigger: "change" },
        ],
        attach_url: [
          {
            required: true,
            message: "请上传文件仅限word文档",
            trigger: "change",
          },
        ],
      },
      fullAttach: "",
    };
  },
  components: {
    uploader,
  },
  created() {
    this.getCity();
    let id = this.$route.query.id;
    if (id) {
      this.showContrl = false;
      this.loadWork(id);
    }
  },
  computed: {
    pageTitle() {
      return this.showContrl ? "添加作品" : "编辑作品";
    },
  },
  methods: {
    async authFile(file) {
      let d = await authFile({ key: file });
      return d.data;
    },
    /**
     * 加载个人作品详情（编辑模式）
     */
    loadWork(id) {
      viewMyWork({ id }).then((d) => {
        const data = d.data || {};
        // 仅回填可编辑字段，避免把 pcc、region_name 等只读字段提交给后端
        const fields = [
          "id",
          "work_type",
          "work_title",
          "group_name",
          "grade",
          "teacher",
          "teacher_phone",
          "school_name",
          "province_id",
          "city_id",
          "region_id",
          "pic_url",
          "attach_url",
          "video_url",
        ];
        fields.forEach((key) => {
          if (data[key] !== undefined && data[key] !== null) {
            // 使用 $set 保证动态字段同样具备响应式（如历史数据缺少字段）
            this.$set(this.ruleForm, key, data[key]);
          }
        });
        // authors 必须是对象数组，避免接口返回 null 时表单校验报错
        if (Array.isArray(data.authors) && data.authors.length) {
          this.ruleForm.authors = data.authors;
        }
        // 根据接口返回的pcc数组回显省市区: [province_id, city_id, county_id]
        if (data.pcc && data.pcc.length >= 3) {
          this.ruleForm.province_id = data.pcc[0];
          this.ruleForm.city_id = data.pcc[1];
          this.ruleForm.region_id = data.pcc[2];
          // 根据省份加载市列表（非陕西时需重新加载）
          if (data.pcc[0] && data.pcc[0] !== 61) {
            this.getCity(data.pcc[0]);
          }
          // 根据市加载区县列表
          if (data.pcc[1]) {
            this.getCounty(data.pcc[1]);
          }
        } else if (data.city_id) {
          // 兼容旧数据：单独city_id回显
          this.getCounty(data.city_id);
        }
        this.ruleForm.attach_url &&
          this.authFile(this.ruleForm.attach_url).then((r) => {
            this.fullAttach = r;
            this.attachList.push({
              status: "success",
              name: this.ruleForm.attach_url,
              filePath: this.ruleForm.attach_url,
              url: r,
            });
          });
      });
    },
    beforeUpload(file) {
      const isType = file.name.toLowerCase();
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过20MB!');
        return false;
      }
      if (isType.lastIndexOf('.doc') === -1 && isType.lastIndexOf('.docx') === -1) {
        this.$message.error('上传文件仅限word格式');
        return false;
      }
      return true;
    },
    /**
     * 加载指定省份下所有市，默认陕西省(610000)
     */
    getCity(pid = 610000) {
      getCity({ pid }).then((d) => {
        this.cityList = d.data;
      });
    },
    /**
     * 根据所选市加载区县
     */
    getCounty(pid) {
      getCounty({ pid }).then((d) => {
        this.countyList = d.data;
      });
    },
    /**
     * 切换市时清空区县并重新加载
     */
    changeCity(pid) {
      this.ruleForm.region_id = '';
      this.getCounty(pid);
    },
    attachSuccess(data) {
      this.ruleForm.attach_url =
        data.fileList.length > 0 ? data.fileList[0].filePath : "";
    },
    /**
     * 提交个人作品
     */
    toSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$showLoading();
          saveMyWork(this.ruleForm).then((d) => {
            this.$message.success("作品提交成功");
            this.$router.push("/my-works");
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.douyin-qr {
  position: absolute;
  // left: 120px;
  top: 400px;
  transform: translateY(-50%);
  width: 185px;
  height: auto;
  text-align: center;
  z-index: 1000;
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
  p {
    margin-top: 8px;
    font-size: 12px;
    color: #666;
    line-height: 1.5;
  }
}
.form {
  margin: 40px auto;
  width: 540px;
  .submit {
    color: #6e3621;
    background-color: #F9E8D9;
    border-color: #6e3621;
  }
  .el-upload__tip {
    font-size: 14px;
    color: #6e3621;
    line-height: 24px;

    .up_tip {
      float: left;
      font-size: 26px;
      color: #6e3621;
    }

    .up_text {
      padding-top: 1px;
      overflow: hidden;
      color: #6e3621;
    }

    p {
      margin: 0;
      margin-left: 30px;
      text-indent: -1.15em;
    }
  }

  .inline {
    display: flex;
  }
}
</style>
